/**
 * Model selection dropdown component.
 */
interface ModelSelectorProps {
  value: 'gpt-5' | 'gpt-5-mini' | 'gpt-5-nano'
  onChange: (model: 'gpt-5' | 'gpt-5-mini' | 'gpt-5-nano') => void
  disabled?: boolean
}

export const ModelSelector: React.FC<ModelSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div>
      <label htmlFor="model" className="label">
        AI Model
      </label>
      <select
        id="model"
        value={value}
        onChange={(e) => onChange(e.target.value as any)}
        className="select"
        disabled={disabled}
      >
        <option value="gpt-5">GPT-5 (Best quality, reasoning enabled)</option>
        <option value="gpt-5-mini">GPT-5-mini (Faster, good quality)</option>
        <option value="gpt-5-nano">GPT-5-nano (Fastest, most economical)</option>
      </select>
      <p className="text-sm text-gray-600 mt-1">
        {value === 'gpt-5' && 'Advanced reasoning capabilities for complex reports (recommended)'}
        {value === 'gpt-5-mini' && 'Balanced performance and quality for most use cases'}
        {value === 'gpt-5-nano' && 'Fast generation for simple reports'}
      </p>
    </div>
  )
}
